import React from "react";
import { Box, Button } from "@mui/material";
import { useSelector } from "react-redux";

const SearchBar = ({
  bylist = [],
  label,
  btnLabel,
  handleSearch
}) => {
  const [filterValue, setFilterValue] = React.useState("");
  const [filterField, setFilterField] = React.useState("");
  const user = useSelector((state) => state?.loginState?.auth);
  let  list= ["Search by"].concat(bylist)

  return (<>
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        mb: 2,
        // background: "#d3d3d3",
        gap: 2,
        p: 1,
        borderRadius: 2,
      }}
    >
      <select
        value={filterField}
        onChange={(e) => setFilterField(e.target.value)}
        style={{ maxWidth: 200 }}
      >
        {list.map((b) => <option value={b}>{b}</option>)}
      </select>
      <input
        value={filterValue}
        onChange={(e) => setFilterValue(e.target.value)}
        placeholder="Search value"
      />
      <Box flexGrow={1} />
      <Button className="btn-primary" onClick={()=>filterField!=="Search by"?handleSearch(filterField, filterValue):()=>{}}>
        Search
      </Button>
    </Box>
  </>
  );
};

export default SearchBar;
